export default __webpack_public_path__ + "static/media/1v1_classic_bg.610c821a.png";